import { render, staticRenderFns } from "./VButtonUpload.vue?vue&type=template&id=2c68a0f6&"
import script from "./VButtonUpload.vue?vue&type=script&lang=ts&"
export * from "./VButtonUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports